import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { PageHeader, SectionCard } from "@/components/Common";
import { Button } from "@/components/ui/button";
import { ShieldCheck } from "lucide-react";
import DirectPaymentForm from "@/components/DirectPaymentForm";

const tl = (v) => `${new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(v || 0))} TL`;

function Row({ label, value, testId }) {
  return (
    <div className="flex justify-between gap-4 py-2.5 border-b border-slate-100 last:border-0 text-sm">
      <span className="text-slate-500">{label}</span>
      <span className="font-medium text-slate-900" data-testid={testId}>{value}</span>
    </div>
  );
}

export default function AnnualRenewal() {
  const [params] = useSearchParams();
  const token = params.get("t") || "";
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [paying, setPaying] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/subscription/annual-renewal", { params: { t: token } });
        setInfo(data);
      } catch (e) {
        setErr(e?.response?.data?.detail || "Yenileme bağlantısı doğrulanamadı.");
      }
    })();
  }, [token]);

  if (paying) {
    return <DirectPaymentForm plan="yearly" renewalToken={token} onBack={() => setPaying(false)} />;
  }

  return (
    <div className="space-y-6 max-w-xl" data-testid="annual-renewal-page">
      <PageHeader title="Yıllık Abonelik Yenileme" subtitle="Ödemeniz 3D Secure ile güvenli şekilde alınır" />
      {err && (
        <SectionCard title="Bağlantı kullanılamıyor">
          <div className="p-5 space-y-3 text-sm text-slate-700" data-testid="annual-renewal-error">
            <p>{err}</p>
            <Link to="/abonelik" className="text-emerald-700 underline">Abonelik sayfasına git</Link>
          </div>
        </SectionCard>
      )}
      {info && (
        <SectionCard title="Yenileme Özeti">
          <div className="p-5">
            <Row label="Firma" value={info.company_name} testId="annual-renewal-company" />
            <Row label="Plan" value="Penz Yıllık Abonelik" />
            <Row label="Net fiyat" value={tl(info.net_amount)} testId="annual-renewal-net" />
            <Row label={`KDV (%${Math.round(info.vat_rate * 100)})`} value={tl(info.vat_amount)} testId="annual-renewal-vat" />
            <Row label="Toplam" value={tl(info.total_amount)} testId="annual-renewal-total" />
            <Row label="Ödeme dönemi" value={`${fmtDate(info.billing_period)} – ${fmtDate(info.next_payment_date_after)}`} testId="annual-renewal-period" />
            <Row label="Sonraki yenileme tarihi" value={fmtDate(info.next_payment_date_after)} testId="annual-renewal-next" />
            <Button className="w-full mt-5 h-11 gap-2 bg-slate-900 hover:bg-slate-800" onClick={() => setPaying(true)} data-testid="annual-renewal-pay-btn">
              <ShieldCheck className="w-4 h-4" /> 3D Secure ile Yenile
            </Button>
          </div>
        </SectionCard>
      )}
    </div>
  );
}
